/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileAppSharedClassStudents200,
  GetApiV1NotificationMobileAppSharedClassStudents401,
  GetApiV1NotificationMobileAppSharedClassStudents500,
  GetApiV1NotificationMobileAppSharedClassStudentsQueryParams,
  GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedClassStudents.ts";
import { classStudentNotificationViewModelSchema } from "../classStudentNotificationViewModelSchema.ts";

export const getApiV1NotificationMobileAppSharedClassStudentsQueryParamsSchema =
  z.object({
    searchText: z.optional(z.string()),
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  }) as unknown as ToZod<GetApiV1NotificationMobileAppSharedClassStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileAppSharedClassStudents200Schema =
  z.array(
    z.lazy(() => classStudentNotificationViewModelSchema),
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileAppSharedClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppSharedClassStudents401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1NotificationMobileAppSharedClassStudents500Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppSharedClassStudents500>;

export const getApiV1NotificationMobileAppSharedClassStudentsQueryResponseSchema =
  z.lazy(
    () => getApiV1NotificationMobileAppSharedClassStudents200Schema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedClassStudentsQueryResponse>;
